var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "van-form",
        {
          attrs: { "show-error": false, "label-width": "0" },
          on: { submit: _vm.onSubmit }
        },
        [
          _c("van-field", {
            attrs: {
              clearable: "",
              placeholder: "请输入姓名/名称",
              rules: [{ required: true, message: "必填", trigger: "onChange" }]
            },
            model: {
              value: _vm.form.userName,
              callback: function($$v) {
                _vm.$set(_vm.form, "userName", $$v)
              },
              expression: "form.userName"
            }
          }),
          _c("van-field", {
            attrs: {
              readonly: "",
              clickable: "",
              placeholder: "请选择证件照类型",
              rules: [{ required: true, message: "必选", trigger: "onChange" }]
            },
            on: {
              click: function($event) {
                _vm.showPicker = true
              }
            },
            model: {
              value: _vm.idName,
              callback: function($$v) {
                _vm.idName = $$v
              },
              expression: "idName"
            }
          }),
          _c("van-field", {
            attrs: {
              clearable: "",
              placeholder: "请输入证件号码",
              rules: [{ required: true, message: "必填", trigger: "onChange" }]
            },
            model: {
              value: _vm.form.idNum,
              callback: function($$v) {
                _vm.$set(_vm.form, "idNum", $$v)
              },
              expression: "form.idNum"
            }
          }),
          _c("van-field", {
            attrs: {
              type: "password",
              name: "password",
              clearable: "",
              placeholder: "请输入密码",
              "error-message": _vm.errMsg.password
            },
            on: { change: _vm.validatePassword },
            model: {
              value: _vm.form.password,
              callback: function($$v) {
                _vm.$set(_vm.form, "password", $$v)
              },
              expression: "form.password"
            }
          }),
          _c("van-field", {
            attrs: {
              type: "password",
              name: "rePassword",
              clearable: "",
              placeholder: "请再次输入密码",
              "error-message": _vm.errMsg.rePassword
            },
            on: { change: _vm.equalPassword },
            model: {
              value: _vm.form.rePassword,
              callback: function($$v) {
                _vm.$set(_vm.form, "rePassword", $$v)
              },
              expression: "form.rePassword"
            }
          }),
          _c("van-field", {
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function() {
                  return [
                    _c("van-field", {
                      staticClass: "nobd",
                      attrs: {
                        maxlength: "5",
                        clearable: "",
                        placeholder: "请输入验证码",
                        rules: [
                          {
                            required: true,
                            message: "必填",
                            trigger: "onChange"
                          }
                        ]
                      },
                      model: {
                        value: _vm.form.random,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "random", $$v)
                        },
                        expression: "form.random"
                      }
                    }),
                    _c("van-image", {
                      attrs: {
                        width: "140",
                        height: "35",
                        src: _vm.valid_code_url
                      },
                      on: { click: _vm.getValidCode }
                    })
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c(
            "div",
            { staticClass: "login-btn" },
            [
              _c(
                "van-button",
                { attrs: { block: "", type: "info", "native-type": "submit" } },
                [_vm._v(" 注 册 ")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "login-btn" },
            [
              _c(
                "van-button",
                { attrs: { block: "" }, on: { click: _vm.login } },
                [_vm._v(" 返 回 ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showPicker,
            callback: function($$v) {
              _vm.showPicker = $$v
            },
            expression: "showPicker"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              "value-key": "name",
              columns: _vm.columns
            },
            on: {
              confirm: _vm.onConfirm,
              cancel: function($event) {
                _vm.showPicker = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }